"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES. ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 *
 * COPYRIGHT 2022 BLUECROSS BLUESHIELD OF SOUTH CAROLINA ALL RIGHTS RESERVED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyFormat = void 0;
/**
 * Format a currency value to two fixed places of decimal.
 *
 * @example:
 *  currencyFormat(4) will return '$4.00'
 *  currencyFormat('4000') will return '$4,000.00'
 *  currencyFormat(4, false) will return '4.00'
 *  currencyFormat(' ', true, 'NA') will return 'NA'
 *
 * @param amount The numeric amount to format as a currency
 * @param showSymbol If true, the USD symbol ($) is prefixed to the output string
 * @param defaultText return a default value if input is empty
 * @return the currency formatted to two fixed decimal places, or 'Unavailable' if the currency value is not valid.
 *         article using the regex below:
 * https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
 */
function currencyFormat(amount, showSymbol = true, defaultText = 'Unavailable') {
    let formattedCurrency = defaultText;
    if (typeof amount === 'number') {
        amount = amount.toFixed(2);
        formattedCurrency = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    else if (typeof amount === 'string' && amount.trim().length > 0) {
        const numberValue = Number(amount.replace(',', ''));
        amount = numberValue.toFixed(2);
        formattedCurrency = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    if (showSymbol && (formattedCurrency.trim().length > 0) && formattedCurrency !== defaultText) {
        formattedCurrency = '$' + formattedCurrency;
    }
    return formattedCurrency;
}
exports.currencyFormat = currencyFormat;
//# sourceMappingURL=currency-format.js.map